import React from 'react'
import PropTypes from 'prop-types'
import {TrainingPageTemplate} from '../../templates/training-page'

const TrainingPagePreview = ({ entry, getAsset, widgetFor }) => {
  const entryBlurbs = entry.getIn(['data', 'intro'])
  const blurbs = entryBlurbs ? entryBlurbs.toJS() : []

  const entryTestimonials = entry.getIn(['data', 'testimonials'])
  const testimonials = entryTestimonials ? entryTestimonials.toJS() : []

  return (
    <TrainingPageTemplate
      image={getAsset(entry.getIn(['data', 'image']))}
      title={entry.getIn(['data', 'title'])}
      subtitle={entry.getIn(['data', 'subtitle'])}
      intro={ blurbs }
      testimonials={testimonials}
      content={widgetFor('body')}
    />
  )
}

TrainingPagePreview.propTypes = {
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
  getAsset: PropTypes.func,
  widgetFor: PropTypes.func,
}

export default TrainingPagePreview
